import { render, staticRenderFns } from "./enterpriseDetail.vue?vue&type=template&id=5172faa6"
import script from "./enterpriseDetail.vue?vue&type=script&lang=js"
export * from "./enterpriseDetail.vue?vue&type=script&lang=js"
import style0 from "./enterpriseDetail.vue?vue&type=style&index=0&id=5172faa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports